import { Heading } from '@chakra-ui/react';

export function Dashboard() {
  return <Heading size="md">Dashboard</Heading>;
}
